import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Observable, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';
import { ComparisonUtility } from '@utilities/comparison.utility';

@Injectable({
	providedIn: 'root'
})
export class AppStore {
	public appState$: Observable<AppState>;
	private appStateSource: BehaviorSubject<AppState> = new BehaviorSubject<AppState>(null);
	constructor() {
		this.appState$ = this.appStateSource.pipe(
			distinctUntilChanged((a, b) => ComparisonUtility.isEqual(a, b)),
			map((snapshot) => cloneDeep(snapshot))
		);
		this.updateState((appState) => {
			return appState;
		});
	}

	public updateState(updateFunction?: StateUpdateFunction<AppState>): Observable<void> {
		const updateComplete = new ReplaySubject<void>(1);

		this.appState$.pipe(
			take(1)
		).subscribe((current) => {
			if (!current) {
				current = new AppState();
			}

			const newState = updateFunction?.(current) ?? current;
			const clone = cloneDeep(newState);
			this.appStateSource.next(clone);
			updateComplete.next();
			updateComplete.complete();
		});

		return updateComplete;
	}

}

type StateUpdateFunction<T> = (currentState: T) => T;

export class AppState {
	public isCaseProcessing: boolean;
	public isCaseIndexingOrProcessing: boolean;
	public loginPosterUrl: string = 'assets/images/login-poster-20230325.png';
}
